export default "__VITE_ASSET__CoP3SNAV__"